export default "__VITE_ASSET__TwubCDJR__"